


<div class="card cardsmall">
    <div class="grid grid-nogutter flex-wrap gap-3 p-fluid">
        <div class="col-12 pl-2">
            <form [formGroup]="form">
                <p-tabView> 
                    <p-tabPanel header="{{lang.el('Anagrafica cliente')}}">
                        <div class="formgrid">       
                            <formly-form [model]="model" 
                            [fields]="tabsFields[0].fields" 
                            [options]="options" 
                            [form]="form"></formly-form>                     
                        </div>
                    </p-tabPanel>
                    <p-tabPanel header="Preventivi" *ngIf="action!='new'"> 
                        
                        <p-table [value]="opportunitiesData" 
                            dataKey="id" 
                            [tableStyle]="{ 'min-width': '60rem' }" 
                            [expandedRowKeys]="expandedRows" 
                            (onRowExpand)="onRowExpand($event)" (onRowCollapse)="onRowCollapse($event)">
                            <ng-template pTemplate="caption">
                                <div class="grid">
                                    <div class="col-2">
                                       <button pButton label="{{lang.el('Nuovo preventivo')}}" 
                                            class="p-button-outlined mb-2" icon="pi pi-plus" (click)="nuovoPreventivo()">
                                        </button>
                                    </div>
                                    <div class="col-6" style="text-align:right;">

                                    </div>
                                    <div class="col-2" style="text-align:right;">
                                        <p-button label="{{lang.el('Espandi')}}" icon="pi pi-plus" text (onClick)="expandAll()" />
                                    </div>
                                    <div class="col-2" style="text-align:right;">
                                        <p-button label="{{lang.el('Comprimi')}}" icon="pi pi-minus" text (onClick)="collapseAll()" />                                        
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 5rem"></th>
                                    <th style="width: 5rem"></th>
                                    <th pSortableColumn="num_opp">{{lang.el('Num preventivo')}}<p-sortIcon field="num_opp" /></th>
                                    <th pSortableColumn="name">{{lang.el('Nome')}} <p-sortIcon field="name" /></th>
                                    <th pSortableColumn="assigned_name">{{lang.el('Assegnato a')}} <p-sortIcon field="assigned_name" /></th>
                                    <th pSortableColumn="status">{{lang.el('Stato')}} <p-sortIcon field="status" /></th>
                                    <th pSortableColumn="exp_closing_date">{{lang.el('Data')}} <p-sortIcon field="exp_closing_date" /></th>
                                    <th pSortableColumn="amount">{{lang.el('Importo')}} <p-sortIcon field="amount" /></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-opp let-expanded="expanded">
                                <tr>
                                    <td>
                                        <p-button type="button" 
                                        pRipple [pRowToggler]="opp" 
                                        [text]="true" [rounded]="true" 
                                        [plain]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
                                    </td>
                                    <td>
                               
                                        <button pButton pRipple icon="pi pi-pencil" 
                                        class="p-button-rounded p-button-text" (click)="editPrev(opp)"></button>
                                    </td>
                                    <td>{{ opp.num_opp }}</td>
                                    <td>{{ opp.nome }}</td>
                                    <td>{{ opp.status }}</td>
                                    <td>{{ opp.exp_closing_date }}</td>
                                    <td>{{ opp.amount | currency : 'EUR' }}</td>
                                </tr>
                            </ng-template>
                                <ng-template pTemplate="rowexpansion" let-opp>
                                    <tr>
                                        <td colspan="7">
                                            <div class="p-3">
                                               
                                                <p-table [value]="opp.celle" dataKey="id">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <th pSortableColumn="tipoCella">{{lang.el('Tipo cella')}} <p-sortIcon field="tipoCella" /></th>
                                                            <th pSortableColumn="description">{{lang.el('Descrizione')}} <p-sortIcon field="description" /></th>
                                                            <th pSortableColumn="amount">{{lang.el('Totale')}} <p-sortIcon field="amount" /></th>
                                                            <th pSortableColumn="status">{{lang.el('Stato progetto')}} <p-sortIcon field="status" /></th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-cella>
                                                        <tr>
                                                            <td>{{ cella.tipoCella }}</td>
                                                            <td>{{ cella.description }}</td>
                                                            <td>{{ cella.amount | currency : 'EUR' }}</td>
                                                            <td>
                                                                <p-tag [value]="cella.status" [severity]="getSeverityCella(cella.status)" />
                                                            </td>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="emptymessage">
                                                        <tr>
                                                            <td colspan="6">{{lang.el('Non ci sono celle in questo preventivo.')}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                        </p-table>
                    </p-tabPanel>
                </p-tabView>
            </form>
        </div>
    </div>
</div>
<div class="grid">
    <div class="col-12">
        <div class="flex-1 w-full lg:w-3 xl:w-4 flex flex-column row-gap-3">
            <div class="flex flex-column sm:flex-row gap-3 py-2">
                <button
                pButton pRipple class="p-button-danger flex-1 p-button-outlined" 
                (click)="annulla()"
                label="{{lang.el('Annulla')}}"></button>
                <button  *ngIf="action!='delete'"
                pButton pRipple class="p-button-primary flex-1 border-round" 
                (click)="save()"
                [disabled]="!form.valid"
                label="{{lang.el('Salva')}}" icon="pi pi-fw pi-check"></button>
            </div>
        </div>
    </div>
</div>
<p-toast></p-toast>

